import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import {globalConfigurableData} from '../../../utils/globalConstant';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import FastImage from '../../../common/FastImage';
import {
  smile_coin_black,
  smile_coin_green,
  smile_coin_white,
} from '../../../utils/images';

const BuyReturn = ({investment, returns, isSmileEvent}) => {
  return (
    <View style={{flexDirection: 'row', justifyContent: 'space-evenly'}}>
      <View style={{alignItems: 'center'}}>
        <FormTextLabel labelStyles={styles.title} label={'Investment'} />
        <View style={{flexDirection: 'row', gap: 2, alignItems: 'center'}}>
          {isSmileEvent && (
            <FastImage
              style={{width: 15, height: 15}}
              source={smile_coin_black()}
            />
          )}
          <Text style={styles.subtitleInv}>{investment}</Text>
        </View>
      </View>
      <View style={{alignItems: 'center'}}>
        <FormTextLabel labelStyles={styles.title} label={'Returns'} />
        <View style={{flexDirection: 'row', gap: 2, alignItems: 'center'}}>
          {isSmileEvent && (
            <FastImage
              style={{width: 15, height: 15}}
              source={smile_coin_green()}
            />
          )}
          <Text
            style={[
              styles.subtitleInv,
              {color: globalConfigurableData.profitColor},
            ]}>
            {returns}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default BuyReturn;

const styles = StyleSheet.create({
  title: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
    paddingBottom: 2,
  },
  subtitleInv: {
    ...globalFontStyle.appFontHeading,
    color: globalConfigurableData.primaryTextColor1,
  },
});
